export default __webpack_public_path__ + "static/media/002-guitar.a1465c1a.svg";